import {
  Component,
  Input,
  Output,
  EventEmitter,
  AfterViewChecked,
} from "@angular/core";

@Component({
  selector: "app-global-search",
  templateUrl: "./global-search.component.html",
  styleUrls: ["./global-search.component.scss"],
})
export class GlobalSearchComponent implements AfterViewChecked {
  @Input() placeholder: string = "Search...";
  @Output() search = new EventEmitter<string>();
  @Input() value: string = "";

  searchTerm: string = "";
  debounceTimer: any;
  matches: HTMLElement[] = [];
  totalMatches = 0;
  currentIndex = 0;

  // onSearchChange() {
  //   clearTimeout(this.debounceTimer);

  //   this.debounceTimer = setTimeout(() => {
  //     this.search.emit(this.searchTerm.trim());
  //   }, 400);
  // }
  onSearchClick() {
    clearTimeout(this.debounceTimer);
    this.search.emit(this.searchTerm.trim());
  }
  ngAfterViewChecked() {
    setTimeout(() => {
      const elements = document.querySelectorAll(".match-item");

      this.matches = Array.from(elements) as HTMLElement[];
      this.totalMatches = this.matches.length;

      if (this.currentIndex >= this.totalMatches) {
        this.currentIndex = 0;
      }
    });
  }
  scrollToMatch(index: number) {
    if (!this.matches.length) return;
    const element = this.matches[index];
    const container = element.closest(".table-responsive") as HTMLElement;

    if (container) {
      const containerTop = container.getBoundingClientRect().top;
      const elementTop = element.getBoundingClientRect().top;

      const offset = elementTop - containerTop - 50;

      container.scrollTop += offset;
    } else {
      element.scrollIntoView({ behavior: "smooth", block: "center" });
    }
    this.matches.forEach((el) => el.classList.remove("active-match"));
    element.classList.add("active-match");
  }

  next() {
    if (!this.matches.length) return;
    this.currentIndex = (this.currentIndex + 1) % this.totalMatches;
    this.scrollToMatch(this.currentIndex);
  }

  prev() {
    if (!this.matches.length) return;
    this.currentIndex =
      (this.currentIndex - 1 + this.totalMatches) % this.totalMatches;
    this.scrollToMatch(this.currentIndex);
  }
  ngOnChanges() {
  this.searchTerm = this.value;
}
}
